const getReportType = reportCode => {
  switch (reportCode) {
    case "FM":
      return "Felony and Misdemeanor";
    case "F":
      return "Felony";
    case "M":
      return "Misdemeanor";
    case "FaM":
      return "Felony Plus";
    case "H":
      return "Civil High Court";
    case "Fcr":
      return "Federal Criminal";
    case "Fcv":
      return "Federal Civil";
    case "OW":
      return "Outstanding Warrants";
    case "CRM":
      return "Criminal Search - State Wide";
    case "L":
      return "Lower Court";
    case "MVR":
      return "Motor Vehicle Records";
    case "1005":
      return "Criminal/Federal";
    case "1007":
      return "Criminal/Statewide";
    case "1002":
      return "County Level Felony";
    case "1003":
      return "County Level Misdemeanor";
    case "5031":
      return "Civil/Federal";
    case "5030":
      return "Civil/County";
    default:
      return reportCode;
  }
};

export default getReportType;



// WEBPACK FOOTER //
// ./src/components/myaccount/ReportType.js